import { ArrowRight } from "lucide-react"

import { Button } from "@/components/ui/button"
import { t } from "@/lib/i18n"

import type { LandingLinks } from "./types"

const trustItems = ["orders", "charges", "isolation"]

export function ClosingSection({ links }: { links: LandingLinks }) {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 pb-24 lg:pb-28">
      <div className="grid items-end gap-12 border-t border-brand pt-12 lg:grid-cols-[1fr_26rem] lg:gap-16">
        <div>
          <h2 className="rotulo max-w-[15em] text-balance text-3xl sm:text-4xl lg:text-5xl">
            {t("ui.landing.closing.title")}
          </h2>
          <p className="mt-5 max-w-2xl text-pretty text-base leading-7 text-muted-foreground lg:text-lg lg:leading-8">
            {t("ui.landing.closing.description")}
          </p>
          <div className="mt-8 flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
            <Button asChild size="lg">
              <a href={links.staffRegistration}>
                {t("ui.landing.closing.primary")}
                <ArrowRight />
              </a>
            </Button>
            <Button asChild size="lg" variant="outline">
              <a href={links.staffSignIn}>{t("ui.landing.closing.secondary")}</a>
            </Button>
          </div>
        </div>

        <ul className="flex flex-col">
          {trustItems.map((item) => (
            <li key={item} className="flex flex-col gap-1 border-b py-3.5">
              <span className="text-sm font-semibold">{t(`ui.landing.closing.trust.${item}.title`)}</span>
              <span className="text-sm leading-6 text-muted-foreground">
                {t(`ui.landing.closing.trust.${item}.description`)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
